export const en = {
    'common-price-editor-description-phrases': 'The CPM bid you set will be used for all keywords',
    'common-price-editor-description-retargetings': 'The CPM bid you set will be used for all retargeting lists',
    'common-price-editor-description-users-profile': 'The CPM bid you set will be used for all retargeting lists',
    'common-price-editor-title': 'Single bid',
    'common-price-editor-title-phrases': 'Single bid for keywords',
    'common-price-editor-title-retargetings': 'Single bid for retargeting lists',
    'common-price-editor-title-users-profile': 'Single bid for user profiles',
    'selected-phrases': {
        one: '{count} keyword selected',
        some: '{count} keywords selected',
        many: '{count} keywords selected',
        none: '{count} keywords selected'
    },
    'selected-retargetings': {
        one: '{count} retargeting lists selected',
        some: '{count} retargeting lists selected',
        many: '{count} retargeting lists selected',
        none: '{count} retargeting lists selected'
    },
    'set-cpc-price': 'Set a single CPC bid',
    'set-cpm-price': 'Set a single CPM bid',
    'set-price': 'Set a single bid',
    'single-rate-max-price': 'The single bid must not exceed {maxValue} {currency}',
    'single-rate-min-price': 'The single bid must not be less than {minValue} {currency}'
};
